// extracted by mini-css-extract-plugin
var _1 = "FileComponent_content__315e6";
var _2 = "FileComponent_disabled__eace9";
var _3 = "FileComponent_icon__c97e0";
var _4 = "FileComponent_iconWrapper__1e108";
var _5 = "FileComponent_previewImg__5de26";
var _6 = "FileComponent_root__cd38f";
export { _1 as "content", _2 as "disabled", _3 as "icon", _4 as "iconWrapper", _5 as "previewImg", _6 as "root" }
